import PhonelinkIcon from '@material-ui/icons/Phonelink';
import PowerIcon from '@material-ui/icons/Power';
import UpdateIcon from '@material-ui/icons/Update';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import RefreshIcon from '@material-ui/icons/Refresh';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import SkipNextIcon from '@material-ui/icons/SkipNext';
import MicIcon from '@material-ui/icons/Mic';
import MicNoneIcon from '@material-ui/icons/MicNone';
import MicOffIcon from '@material-ui/icons/MicOff';

import { navigatorDetails } from 'UTILS/navigator';

export const getMicrophoneNotFoundHintList = ({ os = navigatorDetails.os } = {}) => {
  const hintList = [];
  if (os !== 'Android' && os !== 'iOS') {
    hintList.push({
      icon: PowerIcon,
      title: 'checkTheConnections',
      text: 'ifYourMicrophoneIsExternalMakeSureThatItIsConnectedToYourDevice-tryToDisconnectAndReconnectItOnAnotherUsbPortThenRestartTheCheck',
    });
  }
  if (os === 'Windows') {
    hintList.push({
      icon: UpdateIcon,
      title: 'updateTheDriverSoftware',
      text: 'ifYourMicrophoneNeedsADriverSoftwareMakeSureItIsUpToDate',
      buttonList: [{
        href: 'updateDriverSupportLink',
        label: 'stepByStep',
      }],
    });
  }
  return hintList;
};

export const MICROPHONE_RESULT_MAP = {
  'sound_not_detected': {
    message: 'noSoundDetected',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: RecordVoiceOverIcon,
        title: 'makeSomeNoiseDuringTheCheck',
        text: 'runTheCheckAgainAndSpeakNearYourMicrophoneSoThatAVolumeVariationCanBeDetected',
      },
      {
        icon: MicNoneIcon,
        title: 'checkYourMicrophone',
        text: 'checkThatYourMicrophoneIsCloseToYouAndThatItIsNotDustyOrClogged',
      },
      {
        icon: MicOffIcon,
        title: 'unMuteYourMicrophone',
        text: 'someExternalMicrophonesCanBeManuallyMutedCheckThatYoursIsNot-internalMicrophonesMightBeMutedInTheOperatingSystemSettings',
      },
      {
        icon: PowerSettingsNewIcon,
        title: 'restartYourDevice',
        text: 'ifYourMicrophoneIsInternalAndTheAboveSolutionsDidNotWorkRestartYourDeviceAndTryAgain',
      },
    ],
  },
  'volume_check_impossible': {
    message: 'volumeCheckImpossible',
    title: 'whatCanIDoAboutIt',
    hintList: [
      {
        icon: MicIcon,
        title: 'tryAnotherMicrophone',
        text: 'tryTestingAnotherMicrophoneByGoingBackToTheMicrophoneCheckAndSelectingItInTheList',
      },
      {
        icon: PhonelinkIcon,
        title: 'tryAnotherComputerOrSmartphone',
        text: 'ifYouDontHaveOtherMicrophoneOnYourCurrentDeviceTryOpeningTheVideoConferenceLinkOnAnotherDevice-hintSmartPhonesAlwaysHaveMicrophones',
      },
      {
        icon: SkipNextIcon,
        title: 'skipTheTest',
        text: 'thereIsASmallChanceThatYourMicrophoneCanStillPerformVideoConferences-ifTheOtherSuggestionsDidNotWorkYouCanSkipThisCheckAndHopeItWillWorkDuringTheVideoConference',
      },
    ],
  },
  'microphone_not_detected': {
    message: 'microphoneNotDetected',
    title: 'howCanIMakeMyMicrophoneDetected',
    hintList: [
      ...getMicrophoneNotFoundHintList(),
      {
        icon: PowerSettingsNewIcon,
        title: 'restartYourDevice',
        text: 'ifYourMicrophoneIsInternalRestartYourDeviceAndTryAgain',
      },
    ],
  },
  'microphone_not_available': {
    message: 'microphoneNotAvailable',
    title: 'howCanIMakeMyMicrophoneAvailable',
    hintList: [
      {
        icon: CancelPresentationIcon,
        title: 'appOrSoftwareConflict',
        text: 'ifAnotherAppOrSoftwareIsUsingYourMicrophoneItMayNotBeAvailableForVideoConferences-closeAnyAppOrSoftwareThatIsSusceptibleToUseYourMicrophoneSuchAsTeamsFaceTimeOrZoomAndRunTheMicrophoneCheckAgain',
      },
      {
        icon: RefreshIcon,
        title: 'restartTheBrowser',
        text: 'ifYouDoNotHaveAnyPossiblyConflictingAppAndTheCheckStillFailsTryRefreshingThePage-ifItFailsAgainTryRestartingTheBrowser',
        buttonList: [{
          href: document.location.href,
          label: 'refresh',
          self: true,
        }],
      },
      {
        icon: PowerSettingsNewIcon,
        title: 'restartTheDevice',
        text: 'ifRestartingTheBrowserDidNotHelpTryRestartingYourDevice',
      },
    ],
  },
  'no_audio_source': {
    message: 'noMicrophoneDetected',
    title: 'addingMicrophones',
    hintList: [
      {
        icon: MicIcon,
        title: 'plugInAMicrophone',
        text: 'ifYouHaveAnExternalMicrophoneTryPluggingItInAndRunTheMicrophoneCheckAgain-hintEarPhonesUsuallyHaveMicrophones',
      },
      {
        icon: PhonelinkIcon,
        title: 'tryAnotherComputerOrSmartphone',
        text: 'ifYouDontHaveAnyExternalMicrophoneToPlugInTryOpeningTheVideoConferenceLinkOnAnotherDevice-hintSmartPhonesAlwaysHaveMicrophones',
      },
    ],
  },
  'microphone_detected': {
    message: 'microphoneDetected',
  },
};
